/**
 *	shop-info.ctrl.js
 */

class ShopInfoCtrl {
    constructor($location, $anchorScroll, shopTypesServ) {
        this.$location = $location;
        this.$anchorScroll = $anchorScroll;
        this.shopTypesServ = shopTypesServ;
    }

    scrollToHash(hash) {
        this.$location.hash(hash);
        this.$anchorScroll();
    }
}

ShopInfoCtrl.$inject = ['$location', '$anchorScroll', 'shopTypesServ'];

export default ShopInfoCtrl;